import * as React from 'react'
function SvgOcr(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M6 28a2 2 0 012 2v2h2a2 2 0 110 4H6a2 2 0 01-2-2v-4a2 2 0 012-2zm28 0a2 2 0 012 2v4a2 2 0 01-2 2h-4a2 2 0 110-4h2v-2a2 2 0 012-2zM20 10a6 6 0 016 6v1a7.138 7.138 0 01-3.434 6.4l.064.38a4 4 0 002.46 3.056L28 28v2H12v-2l2.91-1.158a4 4 0 002.46-3.056l.064-.386A7.138 7.138 0 0114 17v-1a6 6 0 016-6zM10 4a2 2 0 110 4H8v2a2 2 0 11-4 0V6a2 2 0 012-2h4zm24 0a2 2 0 012 2v4a2 2 0 11-4 0V8h-2a2 2 0 110-4h4z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgOcr
